import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, InputGroup } from 'react-bootstrap';
import Swal from 'sweetalert2';
import APIserver from '../../../../api/axiosConfig';

function EditProductoModal({ show, handleClose, producto, fetchProductos }) {
  const [formData, setFormData] = useState({
    referencia: '',
    nombre: '',
    stock: 0,
    precioCompra: 0,
    precioVenta: 0,
    precioMayor: 0,
  });
  const [cantidad, setCantidad] = useState(0); // Nuevo estado para la cantidad

  useEffect(() => {
    if (producto && Object.keys(producto).length > 0) {
      setFormData({
        referencia: producto.referencia || '',
        nombre: producto.nombre || '',
        stock: producto.stock || 0,
        precioCompra: producto.precioCompra || 0,
        precioVenta: producto.precioVenta || 0,
        precioMayor: producto.precioMayor || 0,
      });
    }
  }, [producto]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cantidad') {
      setCantidad(parseInt(value, 10));
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const stockValue = formData.stock + cantidad; // Actualizar el stock basado en la cantidad
    const precioCompraValue = parseFloat(formData.precioCompra);
    const precioVentaValue = parseFloat(formData.precioVenta);
    const precioMayorValue = parseFloat(formData.precioMayor);

    if (isNaN(stockValue) || isNaN(precioCompraValue) || isNaN(precioVentaValue) || isNaN(precioMayorValue)) {
      Swal.fire({
        title: 'Error',
        text: 'Por favor, ingresa valores válidos para stock, precio de compra y precio de venta.',
        icon: 'error',
        iconColor: '#da292e',
        confirmButtonColor: '#da292e',
      });
      return;
    }

    const formDataToSend = {
      referencia: formData.referencia,
      nombre: formData.nombre,
      stock: stockValue,
      precioCompra: precioCompraValue,
      precioVenta: precioVentaValue,
      precioMayor: precioMayorValue,
    };

    try {
      const response = await APIserver.put(`/api/productos/${producto.idProducto}`, formDataToSend);

      if (response.status === 200) {
        Swal.fire({
          title: 'Éxito',
          text: 'Producto actualizado correctamente.',
          icon: 'success',
          iconColor: '#2fb380',
          confirmButtonColor: "#2c4cc4"
        });
        handleClose();
        fetchProductos();
      }
    } catch (error) {
      console.error('Error actualizando el producto:', error);
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al actualizar el producto.',
        icon: 'error',
        iconColor: '#da292e',
        confirmButtonColor: "#da292e"
      });
    }
  };

  return (
    <Modal size='lg' show={show} onHide={handleClose} aria-labelledby="modal-editar-producto">
      <Modal.Header closeButton>
        <Modal.Title>Editar Producto {formData.referencia}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group className='m-3 mt-0'>
                <Form.Label>Referencia</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Referencia del producto'
                  name='referencia'
                  value={formData.referencia}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className='m-3'>
                <Form.Label>Stock</Form.Label>
                <Form.Control
                  type='number'
                  placeholder='Cantidad en stock'
                  name='stock'
                  value={formData.stock}
                  onChange={handleChange}
                  required
                  disabled
                />
              </Form.Group>
              <Form.Group className='m-3'>
                <Form.Label>Cantidad a Actualizar</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Cantidad a agregar o restar"
                  name="cantidad"
                  value={cantidad}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Permitir solo números y un único "-" al inicio
                    if (/^-?\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  required
                />

              </Form.Group>
              <Form.Group className='m-3'>
                <Form.Label>Precio Venta Unidad</Form.Label>
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <Form.Control
                    type='number'
                    placeholder='Precio de venta'
                    name='precioVenta'
                    value={formData.precioVenta}
                    onChange={handleChange}
                    required
                  />
                  <InputGroup.Text>COP</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className='m-3 mt-0'>
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Nombre del producto'
                  name='nombre'
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group className='m-3'>
                <Form.Label>Precio de Compra</Form.Label>
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <Form.Control
                    type='number'
                    placeholder='Precio de compra'
                    name='precioCompra'
                    value={formData.precioCompra}
                    onChange={handleChange}
                    required
                  />
                  <InputGroup.Text>COP</InputGroup.Text>
                </InputGroup>
              </Form.Group>
              <Form.Group className='m-3'>
                <Form.Label>Precio Venta x Mayor</Form.Label>
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <Form.Control
                    type='number'
                    placeholder='Precio de venta x Mayor'
                    name='precioMayor'
                    value={formData.precioMayor}
                    onChange={handleChange}
                    required
                  />
                  <InputGroup.Text>COP</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
          <Modal.Footer>
            <Button variant='dark' onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant='danger' type='submit'>
              Guardar Cambios
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default EditProductoModal;
